// src/pages/Home.jsx

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // заменяем текущий путь на /admin
    navigate('/admin', { replace: true });
  }, [navigate]);

  return null;
};

export default Home;
